import React from "react";
import { FormProvider } from "react-hook-form";
import { Edit } from "@refinedev/mui";

import { PartnerForm } from "@modules/partners/components";
import { usePartnerEditForm } from "./controller";

export const PartnerEdit = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending, formLoading, id } = usePartnerEditForm();

  return (
    <Edit
      recordItemId={id}
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
      isLoading={formLoading}
    >
      <FormProvider {...methods}>
        <PartnerForm />
      </FormProvider>
    </Edit>
  );
});
